import React, { useCallback, useRef, useEffect, useState } from "react";
import {
  Box,
  Button,
  DropdownBody,
  DropdownItem,
  Icons,
  Modal,
  useToast,
} from "fds";
import "./index.scss";
import { MenuListType } from "../../types/files";
import utilsCommon from "../../shared/utils/common";
import { Workgroup } from "../../types/workgroup";
import WorkgroupInfoModal from "../WorkgroupModal";
import { handleExitWorkgroup, handleSetFavorite } from "../../shared/utils/api";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { t } from "i18next";
import LeaveWorkgroupModal from "./LeaveWorkgroupModal";

interface WorkgroupSettingButtonProps {
  workgroupSettingInfo: {
    x: number;
    y: number;
    id: string;
    workgroupInfo?: Workgroup;
  };
  setWorkgroupSettingInfo: (req: {
    x: number;
    y: number;
    id: string;
    workgroupInfo?: Workgroup;
  }) => void;
}
const WorkgroupSettingButton: React.FC<WorkgroupSettingButtonProps> = ({
  workgroupSettingInfo,
  setWorkgroupSettingInfo,
}) => {
  const direction = document.documentElement.dir; // 'ltr' 또는 'rtl'
  const { workgroupState, withdrawMember, updateWorkgroupFavorite } =
    useWorkgroupStore();
  const inputRef = useRef<HTMLTableRowElement>(null);
  const [modalType, changeModalType] = useState("CLOSE");
  const [height, setHeight] = useState(0);

  let menus = [
    {
      key: "workgroupInfo_user",
      resource: t("file.detail"),
      icon: <Icons variant="line" label="detailInfo" />,
      onClick: () => changeModalType("WORKGROUPDETAIL_USER"),
    },
    {
      key: "workgroupInfo_master",
      resource: t("workgroup.setting"),
      icon: <Icons variant="line" label="setting" />,
      onClick: () => changeModalType("WORKGROUPDETAIL_MASTER"),
    },
    {
      key: "workgroupRename",
      resource: t("common.rename"),
      icon: <Icons variant="line" label="edit2" />,
      onClick: () => changeModalType("WORKGROUPDETAIL_MASTER"),
    },
    {
      key: "workgroupFav",
      resource: t("workgroup.unfavWorkgroup"),
      icon: <Icons variant="line" label="star" isOn />,

      onClick: () => {
        handleSetFavorite(
          workgroupSettingInfo?.workgroupInfo?.workgroupId,
          updateWorkgroupFavorite,
          workgroupState.workgroupSidemenuList ?? []
        );
        handleTurnOffSettng();
      },
    },
    {
      key: "workgroupUnFav",
      resource: t("workgroup.favWorkgroup"),
      icon: <Icons variant="fill" label="star" isColored />,
      onClick: () => {
        handleSetFavorite(
          workgroupSettingInfo?.workgroupInfo?.workgroupId,
          updateWorkgroupFavorite,
          workgroupState.workgroupSidemenuList ?? []
        );
        handleTurnOffSettng();
      },
    },
    { key: "divider_workgroup" },
    {
      key: "exitWorkgroup",
      resource: t("workgroup.exit"),
      icon: <Icons variant="line" label="exit" />,
      onClick: () => changeModalType("EXIT_WORKGROUP"),
    },
  ] as {
    key: MenuListType;
    resource: string;
    icon: React.ReactNode;
    onClick?: () => void;
  }[];

  const handleClickOutside = useCallback((e: MouseEvent) => {
    if (inputRef.current && !(inputRef.current! as any).contains(e.target)) {
      setWorkgroupSettingInfo({
        x: 0,
        y: 0,
        id: "",
        workgroupInfo: undefined,
      });
      document.removeEventListener("click", handleClickOutside, true);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });
  useEffect(() => {
    if (!inputRef.current) return;
    const observer = new ResizeObserver(() => {
      if (inputRef.current) {
        setHeight(inputRef.current.offsetHeight);
      }
    });
    observer.observe(inputRef.current);
    return () => observer.disconnect();
  }, []);
  const handleTurnOffSettng = () => {
    setWorkgroupSettingInfo({
      x: 0,
      y: 0,
      id: "",
      workgroupInfo: undefined,
    });
    changeModalType("CLOSE");
  };
  return modalType !== "CLOSE" ? (
    <>
      {modalType === "EXIT_WORKGROUP" && (
        <LeaveWorkgroupModal
          open={modalType === "EXIT_WORKGROUP"}
          onClose={handleTurnOffSettng}
          withdrawMember={withdrawMember}
          submtiAfter={handleTurnOffSettng}
          workgroupInfo={workgroupSettingInfo.workgroupInfo}
        />
      )}
      {modalType.includes("WORKGROUPDETAIL") && (
        <WorkgroupInfoModal
          open={true}
          isWorkgroupManager={modalType === "WORKGROUPDETAIL_MASTER"}
          workgroupInfo={workgroupSettingInfo.workgroupInfo}
          workgroupSettingInfo={workgroupSettingInfo}
          setWorkgroupSettingInfo={setWorkgroupSettingInfo}
          onClose={() => changeModalType("CLOSE")}
        />
      )}
    </>
  ) : (
    <DropdownBody
      maxWidth={300}
      maxHeight={350}
      dropdownRef={inputRef}
      minWidth={190}
      location={{
        x:
          workgroupSettingInfo.x -
          (direction === "ltr" && workgroupSettingInfo.x > window.innerWidth / 2
            ? 190
            : direction !== "ltr"
            ? -240
            : 0),
        y:
          workgroupSettingInfo.y -
          (workgroupSettingInfo.y > window.innerHeight / 2 ? height : 0),
      }}
    >
      {menus
        .filter((item) =>
          utilsCommon.checkMenuAvailble(
            item.key,
            workgroupSettingInfo.workgroupInfo
          )
        )
        .map((item) => (
          <DropdownItem
            height={item.key.includes("divider") ? undefined : 20}
            type={item.key === "exitWorkgroup" ? "warning" : "default"}
            state={item.key.includes("divider") ? "divider" : "default"}
            label={item.resource}
            frontIcon={item.icon}
            onClick={item.onClick}
          />
        ))}
    </DropdownBody>
  );
};
export default WorkgroupSettingButton;
